module.exports = __webpack_public_path__ + "img/logoQr.c1b99322.png";